import { render, staticRenderFns } from "./MenuSidebar.vue?vue&type=template&id=7dc29b0c&scoped=true"
import script from "./MenuSidebar.vue?vue&type=script&lang=js"
export * from "./MenuSidebar.vue?vue&type=script&lang=js"
import style0 from "@/styles/views/MenuSidebar/MenuSidebar.less?vue&type=style&index=0&id=7dc29b0c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc29b0c",
  null
  
)

export default component.exports